export const MIN_PASSWORD_LENGTH = 8;
export const MAX_EDITOR_WORDS_COUNT = 5000;
export const MIN_GRAMMAR_WORDS = 200;
export const DEBOUNCE_DELAY = 300;
export const THROTTLE_DELAY = 300;
